import { useEffect, useState, useRef } from "react";
import "./Dropdown.css";

const Dropdown_Status = (props) => {
  const { label, value, onChange, options, inputBox , projectStatus,selectedID} = props;
  // console.log('options ===> ', options  + '  projectStatus ===> ', projectStatus + '    value ===> ', value );
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);

  let useClickOutside = (handler) => {
    let domNode = useRef();
  
    useEffect(() => {
      let isHandler = (event) => {
        if (!domNode.current.contains(event.target)) {
          handler();
        }
      };
  
      document.addEventListener("mousedown", isHandler);
  
      return () => {
        document.removeEventListener("mousedown", isHandler);
      };
    });
  
    return domNode;
  };

  let domNode = useClickOutside(() => {
    setIsOptionsVisible(false);
  });

  const handleSelected = (value) => {
    onChange(value);
    setIsOptionsVisible(false);
  };
  let displayValue = value;
  const idx = options?.findIndex((opt) => opt.value === value);
  if (idx !== undefined && idx !== -1) displayValue = options[idx].label;
  return (
    <div className="dropdown-status">
      {label && <span className="dropdown-lable">{label}</span>}
      <div ref={domNode} className="dropdown-component-status">
        <div className="selected-options-wrapper-status" onClick={() => setIsOptionsVisible(!isOptionsVisible)}>          
          <div className="displayvalue-status">
            <div className={projectStatus === "inProgressClass" ? "inProgressClass" : projectStatus === "approvedClass" ? "approvedClass" : projectStatus === "needsReviewClass" ? "needsReviewClass" : "defaultStatusClass"}>
              {inputBox ? <input type="number" className="dropdownInput" value={value} onChange={(evt) => {if (onChange) {onChange(evt.target.value);}}} /> : displayValue}
            </div>
          </div>
          <div className="icon-box-status">
          {isOptionsVisible ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-chevron-up"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <polyline points="6 15 12 9 18 15"></polyline>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-chevron-down"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          )}
          </div>
        </div>
        {isOptionsVisible && (
          <div className="dropdown-options-status">
            {options?.map((option,ind) => (
              <div className="dropdown-status-list " onClick={() => handleSelected(option.value)}>
                <div className={"dropdown-label-status" +(ind === selectedID ? " dropdown-label-render-selected" : '')}>{option.label}</div>
                <hr className="dropdown-hr"/>
              </div>
            ))}           
          </div>
        )}
      </div>
    </div>
  );
};
export default Dropdown_Status;
